import { Button, Card, Flex, Image, Tooltip, Typography, Skeleton, Modal, Input, message } from "antd";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postExchnagePrice, postExchnagePriceDataReset } from "../../redux/about/actionCreator";

const { Text } = Typography;

const ExchangePrice = ({ data, setSelectedOldPhone, selectedOldPhone, exchangeModels }) => {
    const dispatch = useDispatch()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [customerNumber, setCustomerNumber] = useState("");
    const offers = [
        { vendor: "Cashify", logo: "/image/cashify.png", price: data?.cashify },
        { vendor: "Grest", logo: "/image/grest.png", price: data?.grest },
        { vendor: "Yaantra", logo: "/image/yaantra.png", price: data?.yaantra },
        { vendor: "SwitchKart", logo: "/image/switchkart.png", price: data?.switchkart },
    ];
    const sortedOffers = offers.filter((data) => data && data.price > 0)
        .sort((a, b) => b.price - a.price);

    const postExchnagePricenData = useSelector(
        state => state.postExchnagePriceData || { data: [], loading: false, error: null }
    )
    console.log(postExchnagePricenData);

    const handleSendToCustomer = () => {
        setIsModalVisible(true);
    };
    const submitExchangeData = () => {
        if (!/^\d{10}$/.test(customerNumber)) {
            message.error("Please enter a valid 10-digit phone number.");
            return;
        }

        const validOffers = offers.filter(
            o => typeof o.price === "number" && o.price > 0
        );

        if (!validOffers.length) {
            message.error("No valid exchange offers available.");
            return;
        }

        const highestOffer = validOffers.reduce((max, curr) =>
            curr.price > max.price ? curr : max
        );

        const model = exchangeModels?.find(m => m.id === selectedOldPhone);
        const payload = {
            customer_mobile: customerNumber,
            exchange_model: model?.model_name,
            exchange_price: highestOffer.price,
            vendor: highestOffer.vendor,
            token: localStorage.getItem("sectionId")
        };

        console.log(payload);
        dispatch(postExchnagePrice(payload));
    };

    useEffect(() => {
        const { loading, data, error } = postExchnagePricenData;
        if (loading) return

        if (data && !Array.isArray(data) && !loading) {
            setIsModalVisible(false)
            message.success(data);
            setCustomerNumber("")
            dispatch(postExchnagePriceDataReset());
        } else if (error && !loading) {
            message.error(error)
            dispatch(postExchnagePriceDataReset());
        }
    }, [postExchnagePricenData, dispatch]);

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Card
            styles={{ header: { minHeight: "auto", padding: "6px" } }}
            extra={
                <Tooltip title="Close">
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => setSelectedOldPhone(null)}
                    />
                </Tooltip>
            }

            title={
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <span>Mobile Exchange Price</span>
                        <Tooltip title="Show Info">
                            <Button
                                type="text"
                                icon={<InfoCircleOutlined />}
                                // onClick={""}
                                style={{ fontSize: 16 }}
                            />
                        </Tooltip>
                    </div>
                    {sortedOffers.length > 0 &&
                        <Button
                            size="small"
                            type="primary"
                            onClick={handleSendToCustomer}
                            style={{ height: "28px", fontSize: "12px", padding: "0 12px" }}
                        >
                            Send to Customer
                        </Button>
                    }
                </div>
            }
        >
            <Flex wrap justify="center" align="center" gap={16} style={{ width: "100%" }}>
                {sortedOffers.length > 0 && sortedOffers.map((offer, i) => (
                    <Flex
                        key={i}
                        align="center"
                        justify="center"
                        gap={8}
                        style={{
                            flex: "1 1 180px",
                            maxWidth: "240px",
                            minWidth: "160px",
                        }}
                    >
                        <Flex align="center" justify="center" style={{ width: '70px', height: "40px", flexShrink: 0 }}>
                            <Image
                                src={offer.logo}
                                alt="Offer Icon"
                                preview={false}
                                style={{ borderRadius: '8px', objectFit: "contain", maxHeight: "40px" }}
                            />
                        </Flex>
                        <div style={{ width: "1px", height: "20px", background: "#BFC1C5", flexShrink: 0 }}></div>
                        <span style={{ textAlign: "left", fontSize: "8px", fontWeight: "bold", lineHeight: 1.2, flexShrink: 0 }}>Up to<br /> ₹</span>
                        {
                            (offer.price === null || offer.price === undefined) ?
                                <Skeleton.Input active size="small" />
                                :
                                <Text style={{ fontSize: "14px", whiteSpace: "nowrap", lineHeight: 1 }} strong>{offer.price}</Text>
                        }
                    </Flex>
                ))}
            </Flex>
            <Modal
                title="Enter Customer Number"
                open={isModalVisible}
                onOk={submitExchangeData}
                onCancel={handleCancel}
                okText="Send"
                cancelText="Cancel"
                centered
            >
                <Input
                    min={10}
                    placeholder="Enter customer phone number"
                    value={customerNumber}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onChange={(e) => {
                        const onlyDigits = e.target.value.replace(/\D/g, "");
                        setCustomerNumber(onlyDigits);
                    }}
                />
            </Modal>
        </Card>
    );
};

export default ExchangePrice;
